module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.5-127.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.6.5.md
// module id = 545
// module chunks = 255